<template>
  <div class="NavBarRight__wrapper">
    <NavBarSearch class="NavBarRight__search"/>
    <el-dropdown
    v-if="false"
    trigger="click"
    class="NavBarRight__notification">
      <SvgImage imageName="NavBarNotification"/>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item disabled>
          No notifications
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dropdown trigger="click">
      <img
      class="NavBarRight__avatar"
      :src="user.avatarUrl || '/images/default-user-avatar.jpg'"/>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item disabled>
          <div class="NavBarRight__user">
            <span class="NavBarRight__user__name">
              {{ userName }}
            </span>
            <div class="NavBarRight__user__progress__wrapper">
              <div
              class="NavBarRight__user__progress"
              :style="{ width: `${cloudStoragePercent}%` }"/>
            </div>
            <span class="NavBarRight__user__usage">
              {{ cloudStoragePercent }}% of {{ cloudStorageAvailableGb }} GB used
            </span>
          </div>
        </el-dropdown-item>
        <el-dropdown-item
        divided>
          <router-link
          tag="div"
          :to="{name: 'settings'}">
            Settings
          </router-link>
        </el-dropdown-item>
        <el-dropdown-item>
          <div
          @click="logout(false)">
            Logout
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import NavBarSearch from '@/components/globals/nav-bar/right/search/NavBarRightSearch'

import UserMixin from '@/components/mixins/User.mixin'

export default {
  name: 'NavBarRight',

  components: {
    NavBarSearch
  },

  mixins: [
    UserMixin
  ],

  methods: {
    ...mapActions('user', [
      'logout'
    ])
  }
}
</script>

<style lang="scss">
@import 'NavBarRight';
</style>
